import type { DefectCatalogItem } from '../contracts/availableLayers';
import type { Recipe } from '../contracts/recipes';
import { getTenantIdFromStorage, slugifyTenant } from 'utils/tenant';


export interface DefectOverlayTenantOptions {
  readonly tenantId?: string | null;
}

export interface TenantDefectOverlayAdapter {
  readonly id: string;
  readonly tenantSlug: string;
  readonly recipeIds: ReadonlySet<string>;
  mergeCatalog: (
    defects: readonly DefectCatalogItem[],
    surveyTypes?: readonly string[],
  ) => readonly DefectCatalogItem[];
  getRecipes: () => readonly Recipe[];
}

export function resolveOverlayTenantSlug(
  tenantId?: string | null,
): string | null {
  const raw =
    tenantId === undefined ? getTenantIdFromStorage() ?? null : tenantId;
  if (raw == null) {
    return null;
  }
  const slug = slugifyTenant(raw);
  return slug.length > 0 ? slug : null;
}
